/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import React, { useRef, useState, useContext, useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as Sentry from '@sentry/nextjs';

import { useRouter } from 'next/router';
import getConfig from 'next/config';

import { CustomerContext } from 'context/customer';
import { ModalContext } from 'context/modal';

import { logMparticleEvent, mParticleCustomEvents, mParticleEventTypes } from 'helpers/mParticle';
import { readAddressFromLocalStorage } from 'helpers/localStorage';

import useIsBrowser from 'hooks/useIsBrowser';
import usePageviewAnalytics from 'hooks/usePageviewAnalytics';

import ModalComponents, { AuthModalStates } from 'types/modals';

import Meta from 'components/shared/Meta/Meta';
import Acquisition from 'components/views/home/Acquisition/Acquisition';
import Hero from 'components/views/home/Hero/Hero';
import DinerModule from 'components/views/home/DinerModule/DinerModule';
import RestaurantSolutions from 'components/views/home/RestaurantSolutions/RestaurantSolutions';
import Nav from 'components/shared/Nav/Nav';
import Footer from 'components/shared/Footer/Footer';

export default function Home() {
  usePageviewAnalytics();
  const isBrowser = useIsBrowser();
  const acquisitionRef = useRef(null);

  const [stickyTopNav, setStickyTopNav] = useState(false);

  const { user, hasFetched } = useContext(CustomerContext);
  const { showModal } = useContext(ModalContext);

  const router = useRouter();

  const queryParams = router.query;

  useEffect(
    () =>
      // Close branch journey on unmount
      () => {
        const { branch } = window;
        const branchElement = document.getElementById('branch-banner-iframe');
        if (branch && branchElement) {
          branchElement.style.display = 'none';
          document.body.style.transition = '';
          branch.closeJourney();
        }
      },
    []
  );

  useEffect(() => {
    const { branch } = window;
    const { publicRuntimeConfig } = getConfig();
    if (branch) {
      branch.init(publicRuntimeConfig.branchIOKey);
    }
  }, []);

  useEffect(() => {
    if (queryParams.email && queryParams.verify && !user) {
      // on load, if we have forgot password queries, open auth modal to reset pw
      showModal({
        modalType: ModalComponents.AUTH,
        modalProps: {
          activeAuthModal: AuthModalStates.RESET_PASSWORD,
          email: queryParams.email,
          resetVerifyCode: queryParams.verify,
        },
      });
      // remove queryParams;
      router.replace('/', undefined, { shallow: true });
    }
  }, [queryParams]);

  useEffect(() => {
    if (hasFetched) {
      logMparticleEvent({
        eventName: mParticleCustomEvents.viewWebHomepage,
        eventType: mParticleEventTypes.Other,
        attributes: {
          default_search_term: readAddressFromLocalStorage().formatted_address,
          url: router.pathname,
          user_is_authenticated: !!user,
        },
      });
    }
  }, [hasFetched]);

  function handleStickyStateChange(inView) {
    if (stickyTopNav === inView) {
      setStickyTopNav(!inView);
    }
  }

  function handleScroll() {
    acquisitionRef.current.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div>
      <Meta isHomepage />
      {isBrowser && <Nav homeNav handleScroll={handleScroll} />}
      <Hero handleStickyStateChange={handleStickyStateChange} isClient={isBrowser} />
      <DinerModule handleScroll={handleScroll} />
      <RestaurantSolutions />
      <Acquisition ref={acquisitionRef} />
      <Footer />
    </div>
  );
}

export async function getServerSideProps() {
  return { props: {} };
}
